import React from "react";
import "../../../../../Assets/Styles/IconCheckbox.scss";

const IconCheckbox = (props) => {
  const checkItem = () => {
    document.getElementById(props.Name + "-icon-checkbox").click();
    if (document.getElementById(props.Name + "-icon-checkbox").checked) {
      document.getElementById(props.Name + "-icon").src = props.ActiveIcon;
    } else {
      document.getElementById(props.Name + "-icon").src = props.DeactiveIcon;
    }
  };
  return (
    <React.Fragment>
      {props.IsDefaultActive ? (
        <span className="icon-checkbox">
          <input
            type="checkbox"
            className="hidden"
            defaultChecked={true}
            id={props.Name + "-icon-checkbox"}
            onChange={() => props.ChangeHandler()}
          />
          <button onClick={() => checkItem()}>
            <img id={props.Name + "-icon"} alt="" src={props.ActiveIcon} />
          </button>
        </span>
      ) : (
        <span className="icon-checkbox">
          <input
            type="checkbox"
            className="hidden"
            id={props.Name + "-icon-checkbox"}
            onChange={() => props.ChangeHandler()}
          />
          <button onClick={() => checkItem()}>
            <img id={props.Name + "-icon"} alt="" src={props.DeactiveIcon} />
          </button>
        </span>
      )}
    </React.Fragment>
  );
};
export default IconCheckbox;
